module.exports = __webpack_public_path__ + "img/glogo208.86fe37b5.png";